import React from 'react';
import Link from 'next/link';
import { UseCase } from '@/types/use-case';

interface Category {
  industry: string;
  items: UseCase[];
}

interface UseCasesSidebarProps {
  categories: Category[];
  activeId?: string; // currently viewed use case id
  toggleSidebar: () => void;
}

export default function UseCasesSidebar({ categories, activeId, toggleSidebar }: UseCasesSidebarProps) {
  return (
    <aside className="side-nav sticky top-8 self-start pr-8">
      <div className="mb-2 pb-2 border-b border-gray-200 flex justify-end items-center">
        <button
          onClick={toggleSidebar}
          className="hide-sidebar-btn w-14 h-8 bg-primary hover:bg-primary-dark text-white rounded-full flex items-center justify-center shadow-md transition-colors duration-200"
          style={{ width: '26px', height: '26px' }}
          aria-label="Hide Sidebar"
          title="Hide Sidebar"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H3zm10 1H7v10h6V4z" clipRule="evenodd" />
          </svg>
        </button>
      </div>

      <div className="max-h-[calc(100vh-120px)] overflow-y-auto">
        {categories.map((cat) => (
          <div key={cat.industry} className="mb-6">
            <h3 className="text-sm font-semibold text-gray-600 mb-2 uppercase tracking-wide">
              {cat.industry}
            </h3>
            <ul className="list-none space-y-1">
              {cat.items.map((uc) => (
                <li key={uc.id}>
                  <Link
                    href={`/use-cases/${uc.id}`}
                    className={`block py-1 px-2 rounded transition-colors duration-150 text-sm ${
                      uc.id === activeId ? 'bg-primary-light text-primary font-medium' : 'hover:bg-gray-50'
                    }`}
                  >
                    {uc.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
} 